import {DeepPartial} from 'redux';
import {INewsState} from '@/@types/models/news';

const news: DeepPartial<INewsState> = {
  pages: {
    active: [],
  },
  detail: {},
  searchWords: [],
  sortState: {
    order: 'asc',
    key: 'id',
  },
  totalCount: 0,
  totalPages: 0,
  current: 1,
};

export default news;
